export const transactionMethod = [
    { label: "Credit Card", value: "creditcard" },
    { label: "Debit Card", value: "debitcard" },
    { label: "Net Banking", value: "netbanking" },
    { label: "UPI", value: "upi" },
    { label: "Amex", value: "amex" },
    { label: "Diner", value: "diner" },
    { label: "Others", value: "others" },
]

export const referralType = [
    { label: "Ecommerce", value: "ecommerce" },
    { label: "Essential", value: "essential" },
]

export const reportTypeConstants = {
    "DAILY_INCENTIVES": "DOWNLOAD_DAILY",
    "MERCHANT_INCENTIVES": "DOWNLOAD_MERCHANT",
    "MERCHANT_INCENTIVES_MID": "DOWNLOAD_MERCHANT_MID",
}

export const incentiveModel = [
    { label: "Convenience Fee", value: "convFee" },
    { label: "TDR", value: "TDR" },
]

export const incentiveFormula = [
    { label: "(Client Conv Fee - Base Rate) * Transaction Amount", value: "convFee" },
    { label: "(Client TDR - Base Rate)* Transaction Amount", value: "TDR" },
]

export const getInvoiceStatus = (status) => {
    switch (status) {
      case "Paid":
        return "Paid";
  
      case "In Progress":
        return "Approved";
  
      case "Pending":
        return "Pending";
  
      case "Disputed":
        return "Disputed";
  
      default:
        return status;
    }
  };

export const invoiceStatusMap = {
    Paid: "SUCCESS",
    Approved: "WARNING",
    Pending: "WARNING",
    Disputed: "DANGER",
}

export const dateFormat = {
    'YMD': 'yyyy-MM-dd'
}
